import '../../styles/how-to-start-list.css';

import GooglePlayDownloadIcon from '../../assets/icons/google-play-download.svg';
import AppStoreDownloadIcon from '../../assets/icons/app-store-download-transparent.svg';
import { _ } from '../../utils/l10n';
import { NativeStoreLinks } from '../NativeStoreLinks';
import DOMPurify from 'isomorphic-dompurify';

export type HowToStartStep = { title: string; text: string };

export interface HowToStartListProps {
  /**
   * List of steps
   */
  steps?: HowToStartStep[];
  /**
   * Indicates whether to show the download step
   */
  showDownloadStep: boolean;
}

const DOWNLOAD_STEP: HowToStartStep = {
  title: 'Download the TWEX<sup>®</sup> App',
  text: 'To start with TWEX<sup>®</sup>, download and register in the mobile app you will be using for transaction signing.',
};

export const HowToStartList = ({ steps = [], showDownloadStep }: HowToStartListProps) => {
  const showStepNumber = (showDownloadStep && steps?.length > 0) || steps?.length > 1;

  const stepsList: HowToStartStep[] = [];
  if (showDownloadStep) {
    stepsList.push(DOWNLOAD_STEP);
  }
  stepsList.push(...steps);

  return (
    <ul className="how-to-start-list">
      {stepsList.map(({ title, text }, index) => (
        <li
          key={title}
          className="how-to-start-list-item"
        >
          {showStepNumber && <div className="how-to-start-list-item-number">{index + 1}</div>}
          <h4
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
            className="how-to-start-list-item-title"
          />
          <div
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
            className="how-to-start-list-item-text"
          />
          {showDownloadStep && index === 0 && (
            <NativeStoreLinks
              googlePlayIcon={GooglePlayDownloadIcon}
              appStoreIcon={AppStoreDownloadIcon}
              appStoreLink="https://apps.apple.com/us/app/twex/id1556701595"
              googlePlayLink="https://play.google.com/store/apps/details?id=io.trustwise.twex"
            />
          )}
        </li>
      ))}
    </ul>
  );
};
